import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationES from './locales/es.json';
import translationEN from './locales/en.json';

// Recursos de traducción
const resources = {
    es: {
        translation: translationES
    },
    en: {
        translation: translationEN
    }
};

i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: 'en', // Idioma por defecto
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false // React ya escapa por defecto
        }
    });

export default i18n;
